import PropTypes from 'prop-types';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const FooterStyle = styled.div.withConfig({
  displayName: "WidgetFooterStyleWrapper__FooterStyle",
  componentId: "j3byt6-0"
})(["display:flex;flex-direction:column;&.mobile{flex-direction:column-reverse;}"]);
function WidgetFooterStyleWrapper({
  mobile = false,
  children
}) {
  return /*#__PURE__*/_jsx(FooterStyle, {
    className: mobile ? "mobile" : "",
    children: children
  });
}
WidgetFooterStyleWrapper.displayName = 'WidgetFooterStyleWrapper';
WidgetFooterStyleWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  mobile: PropTypes.bool
};
export default WidgetFooterStyleWrapper;